import React from 'react';
import ContentLoader from 'react-content-loader';
import { fakeSettings } from '@/constants/constants';

const FakeList = () => {
  const parentDiv = document.getElementsByClassName('container')[0] || window;
  const contentWidth = parentDiv.clientWidth || window.innerWidth;

  return (
    <div className="fakeList">
      <ContentLoader
        height="55"
        width={contentWidth}
        {...fakeSettings}
      >
        <circle cx="50" cy="30" r="25" />
        <rect x="100" y="5" rx="1" ry="1" width="120" height="20" />
        <rect x={contentWidth - 140} y="5" rx="1" ry="1" width="120" height="20" />
        <rect x="100" y="35" rx="1" ry="1" width="90" height="20" />
      </ContentLoader>
    </div>
  )
}
export default FakeList;
